<template>
	<v-card>
		<v-expansion-panel>
			<v-expansion-panel-content>
				<template v-slot:header>
					<div><h3>{{header}}</h3></div>
				</template>
				<div style="padding: 5px" v-for="tag in possibleTags" :key="tag">&emsp; %%{{tag}}%%
				</div>
				<div class="red font-weight-bold" style="padding: 10px">UWAGA: KAŻDY ZNACZNIK W SZABLONIE MUSI BYĆ
					POSTACI %%ZNACZNIK%% BEZ ZMIANY FORMATOWANIA. <br/>
					W RAZIE PROBLEMÓW NALEŻY OTWORZYĆ SZABLON W NOTATNIKU I SPRAWDZIĆ POPRAWNOŚĆ ZNACZNIKÓW.
				</div>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-card>
</template>
<script>
	export default {
		name: 'possibleTags',
		props: {
			possibleTags: {},
			title: {type: String, default: ""},
		},
		computed: {
			header() {
				return this.title === "" ? "Dostępne znaczniki" : this.title;
			}
		}
	};
</script>
